import Vue from 'vue';
import SortedTable from "vue-sorted-table";

Vue.use(SortedTable);
